<template>
  <div :class="['area_info', data.class]">
    <div class="inner_area">
      <strong
        class="tit_info"
        v-html="data.title"
      ></strong>

      <div
        v-if="data.image.src"
        class="wrap_image"
      >
        <img
          v-if="data.image.src !== ''"
          :src="infoImage"
          :alt="data.image.alt"
        />
      </div>
      <p
        v-else
        class="desc_info"
        v-html="data.description"
      ></p>
       <a
          v-if="data.link"
          :href="`/service${data.link.url}`"
          class="btn_link"
          >{{ data.link.text }}<span class="icon_arrow"></span></a
        >
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  infoData: {
    type: Object,
    default() {
      return {};
    },
  },
});
import { useIsWidth } from '/stores/store';
const isWidthStore = useIsWidth();

const data = computed(() => {
  return props.infoData;
});

const infoImage = computed(() => {
  const width = isWidthStore.resolutionList;
  const info = data.value.image.src;
  if (width.isPc) return info.pc;
  if (width.isTablet) return info.tablet;
  return info.mo;
});
</script>
<style lang="scss" scoped>
.area_info {
  padding: 160px 0;
  background-color: #f5f5f5;
  text-align: center;
  &.ty_ito {
    background-color: initial;
  }
}
.inner_area {
  //공통 래퍼사이즈 스타일넣기
  max-width: 1104px;
  margin: 0 auto;
  padding: 0 40px;
}
.tit_info {
  display: block;
  margin: 0 auto;
  font-size: 36px;
  line-height: 1.47;
  letter-spacing: -0.5px;
  color: #1d1d1f;
  word-break: keep-all;
}
.wrap_image {
  margin-top: 60px;
  img {
    width: 100%;
  }
}
.desc_info {
  margin: 24px auto 0;
  font-size: 24px;
  letter-spacing: -0.5px;
  color: #131415;
}
.btn_link {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 362px;
    height: 52px;
    margin: 60px auto 0;
    font-size: 24px;
    font-weight: 500;
    background-color: #F0F0F0;
    border-radius: 152.8px;
  .icon_arrow {
    width: 24px;
    height: 24px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M5 4.89954H19M19 4.89954V18.8995M19 4.89954L5 18.8995' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-size: 24px 24px;
    background-position: center;
    background-repeat:no-repeat;
  }
  &:hover {
    color: #FFF;
    background-color: #1A1A1A;
    .icon_arrow {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M5 4.89954H19M19 4.89954V18.8995M19 4.89954L5 18.8995' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }
  }
}
@media screen and (max-width: 811px) {
  .inner_area {
    padding: 0 20px;
  }
  .tit_info {
    font-size: 24px;
    max-width: 500px;
    padding: 0 20px;
  }
  .desc_info {
    font-size: 14px;
    max-width: 500px;
    padding: 0 20px;
  }
}
</style>
